import { Directive, HostListener } from "@angular/core";
import { VerifyVehicleModalTriggerService } from "../_services/verify-vehicle-modal-trigger.service";

/** Data attribute emitted by Prismic for the verify-vehicle CTA (may be stripped by [innerHTML] sanitization in some paths). */
const RENDER_CTA_DATA_SELECTOR = '[data-action="RENDER_CTA"]';
/** Class selector that survives sanitization; Prismic should add this class to the CTA element for resilience. */
export const VERIFY_VEHICLE_CTA_CLASS = "verify-vehicle-cta-trigger";
const RENDER_CTA_SELECTOR = `${RENDER_CTA_DATA_SELECTOR}, .${VERIFY_VEHICLE_CTA_CLASS}`;

/**
 * Place on the wrapper that contains Prismic slice content (e.g. product-home, home, slice-preview).
 * Listens for clicks on elements with data-action="RENDER_CTA" or class "verify-vehicle-cta-trigger" and triggers the verify vehicle modal flow.
 * Uses the class as a fallback because Angular [innerHTML] sanitization can drop data-* attributes in some render paths.
 * Uses event delegation; call preventDefault() so links with href="#" do not jump the page.
 */
@Directive({
  selector: "[appVerifyVehicleCta]",
  standalone: false,
})
export class VerifyVehicleCtaDirective {
  constructor(private triggerService: VerifyVehicleModalTriggerService) {}

  @HostListener("click", ["$event"])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const cta = target.closest?.(RENDER_CTA_SELECTOR);
    if (!cta) return;
    event.preventDefault();
    event.stopPropagation();
    this.triggerService.trigger();
  }
}
